import { render, staticRenderFns } from "./AdminBooking.vue?vue&type=template&id=0234e10a"
import script from "./AdminBooking.vue?vue&type=script&lang=js"
export * from "./AdminBooking.vue?vue&type=script&lang=js"
import style0 from "./AdminBooking.vue?vue&type=style&index=0&id=0234e10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports